export const Menu = () => {
    return {
        selected: false,
        sticky: false,
        stickyType: 'show',
        previousPosition: 0,
        // Location-based phone number display
        phoneDisplayMode: 'both', // 'us-only', 'uk-only', 'both'
        locationDetected: false, // Start as false to prevent flash

        async init () {
            this.previousPosition = window.scrollY;
            if(window.openForm) {
                this.open('form');
            }
            
            // Initialize location detection
            await this.initLocationDetection();
        },

        async initLocationDetection() {
            try {
                // Dynamic import to avoid loading if not needed
                const { LocationDetector } = await import('./location.js');
                const detector = new LocationDetector();
                
                // Check if we already have location data
                if (detector.checkStoredLocation()) {
                    this.phoneDisplayMode = detector.getDisplayMode();
                } else {
                    // Detect location
                    await detector.detectLocation();
                    this.phoneDisplayMode = detector.getDisplayMode();
                }
                
                // Always set to true after detection attempt
                this.locationDetected = true;
            } catch (error) {
                console.warn('Location detection failed, showing both numbers:', error);
                this.phoneDisplayMode = 'both';
                this.locationDetected = true; // Show fallback
            }
        },

        open(index = true, toggle = true) {
            if(!toggle) {
                this.selected = index;
            } else {
                this.selected = this.isOpen( index ) ? false : index;
            }

            document.body.classList.remove('is-open-form');
            document.body.classList.remove('is-open-menu');

            if(this.isOpen('form')) {
                document.body.classList.add('is-open-form');
            } else if(this.isOpen('menu')) {
                document.body.classList.add('is-open-menu');
            }
        },

        isOpen(index = true) {
            if(index == true) {
                return this.selected != false;
            }
            return this.selected === index;
        },

        checkSticky() {
            const currentPosition = window.scrollY;
            if(currentPosition < 600) {
                this.sticky = false;
            } else {
                this.sticky = true;
            }

            this.stickyType =  (this.previousPosition > currentPosition) ? 'show' : 'hide';

            this.previousPosition = currentPosition;
        },

        isStuck() {
            return this.sticky;
        },

        stuckType(type) {
            return this.stickyType == type;
        },

        checkClose(event) {
            if( event.srcElement.classList.contains('c-button') ||
                event.srcElement.classList.contains('c-arrow-button')) {
                return;
            }

            this.open(false, false);
        },

        // Phone number display methods
        shouldShowUSPhone() {
            return this.phoneDisplayMode === 'us-only';
        },

        shouldShowUKPhone() {
            return this.phoneDisplayMode === 'uk-only';
        },

        shouldShowBothPhones() {
            return this.phoneDisplayMode === 'both';
        }
    }
}
